import React from 'react'

class Loader extends React.Component {
  render() {
    return (
      <div>
        <div className="bb" />
      </div>
    )
  }
}

export default Loader
